import classNames from 'classnames'
import React, { useEffect, useState } from 'react'

type Props = {
  show?: boolean
  quantity?: number
  maxQuantity?: number
  text?: string
  className?: string
  style?: React.CSSProperties
}

export const NumberBadge = ({
  show = true,
  quantity,
  text = '',
  maxQuantity,
  className = 'u-bg-red u-color-white c-header__badge',
  style,
  ...rest
}: Props) => {
  const [animate, setAnimate] = useState(false)
  const [disableAnimation, setDisableAnimation] = useState(true)

  useEffect(() => {
    if (!disableAnimation) setAnimate(true)
  }, [quantity])

  // To prevent animation from running on page-load
  useEffect(() => {
    setTimeout(() => {
      setDisableAnimation(false)
    }, 1000)
  }, [])

  const hasQuantities = maxQuantity && quantity
  const numericResult = hasQuantities && quantity > maxQuantity ? `${maxQuantity}+` : quantity

  return (
    <span
      className={classNames(`c-badge ${className}`, {
        'a-grow': animate,
        'd-none': !show,
      })}
      onAnimationEnd={() => setAnimate(false)}
      style={style}
      {...rest}>
      {quantity ? numericResult : text}
    </span>
  )
}

export default NumberBadge
